import { render, staticRenderFns } from "./TerminalDisplayScreenshot.vue?vue&type=template&id=9b4717be"
import script from "./TerminalDisplayScreenshot.vue?vue&type=script&lang=js"
export * from "./TerminalDisplayScreenshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports